import React, { FC, useState } from 'react';
import { SCUIButton, SCUINoRecordComponent } from '../../../atomic/atoms';
import { SCUIContent } from '../../../atomic/organisms';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { SCUIBillingErrorLogDrawerContent } from './components';
import { SCUIGeneralDrawer, SCUICustomDataGrid, SCUIBreadCrumb } from '../../../atomic/molecules';
import { BillingCommand } from '../../../services/command';
import { Box, Grid } from '@mui/material';
import TimeHelper from '../../../utils/time';

export const BillingErrorLog: FC<any> = () => {
    const { t } = useTranslation();
    const [billinMessageLog, setBillingMessageLog] = useState<any>();
    const [billinTrackingMessageLog, setBillingTrackingMessageLog] = useState<any>();
    const [billingGuid, setBillingGuid] = useState<any>();
    const [datas, setDatas] = React.useState<any>();
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const failedInvoiceList = () => {
        let params: any = {};
        params.getBillingInformationType = 9;
        params.referenceId = 0;
        BillingCommand.PostGetBillingInformation(params).then((res: any) => {
            if (res.data) {
                setDatas(
                    JSON.parse(res.data).map(function (item: any, idx: any) {
                        return {
                            id: idx,
                            message: item.Message,
                            isSucceeded: item.IsSucceeded,
                            trackingMessage: item.TrackingMessage,
                            createOn: item.CreateOn ? TimeHelper.formatDateHour(item.CreateOn) : '-',
                            changeOn: item.ChangeOn ? TimeHelper.formatDateHour(item.ChangeOn) : '-',
                            guid: item.Id,
                        };
                    })
                );
            } else {
                setDatas([]);
            }
        });
    };

    return (
        <SCUIContent>
            <SCUIGeneralDrawer
                open={drawerOpen}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerOpen(false);
                    }
                }}
            >
                {drawerOpen && (
                    <SCUIBillingErrorLogDrawerContent
                        message={billinMessageLog}
                        trackingMessage={billinTrackingMessageLog}
                        guid={billingGuid}
                        onClose={onDrawerClose}
                    />
                )}
            </SCUIGeneralDrawer>
            <Box className="billing-error-log">
                <Grid
                    className="billing-error-log-header"
                    container
                    direction="row"
                    spacing={2}
                    sx={{ marginLeft: '0.5rem' }}
                >
                    <SCUIBreadCrumb title={t('billingServiceLog.billingErrorLogs')} componentLink={'billingErrorLog'} />
                </Grid>
                {datas ? (
                    <Grid className="billing-error-log-results" container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            className="billing-error-log-results-title"
                            sx={{ margin: '1rem' }}
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <h1 className="headtxt">{t('general.searchResults')}</h1>
                        </Grid>

                        <Grid
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Box className="billing-error-log-data-grid" sx={{ width: '100%' }}>
                                <SCUICustomDataGrid
                                    randomId
                                    rows={datas}
                                    columns={[
                                        { field: 'id', headerName: 'id', flex: 1, hide: true },
                                        { field: 'message', headerName: t('general.message'), flex: 1 },
                                        { field: 'guid', headerName: 'id', flex: 1 },
                                        {
                                            field: 'trackingMessage',
                                            headerName: t('general.trackingMessage'),
                                            flex: 1,
                                        },
                                        {
                                            field: 'isSucceeded',
                                            headerName: t('general.status'),
                                            flex: 1,
                                            align: 'center',
                                            headerAlign: 'center',
                                            renderCell: (params: any) => {
                                                if (params.row.isSucceeded)
                                                    return (
                                                        <CheckCircleIcon color="success" className="svg_icons" />
                                                    );
                                                else return <CancelIcon color="error" className="svg_icons" />;
                                            },
                                        },
                                        {
                                            field: 'createOn',
                                            headerName: t('mobileApp.createDate'),
                                            flex: 1,
                                        },
                                        {
                                            field: 'changeOn',
                                            headerName: t('mobileApp.updateDate'),
                                            flex: 1,
                                        },
                                        {
                                            field: 'detay',
                                            headerName: t('general.detail'),
                                            flex: 1,
                                            align: 'center',
                                            headerAlign: 'center',
                                            renderCell: (params: any) => {
                                                const onclick = () => {
                                                    setBillingTrackingMessageLog(params.row.trackingMessage);
                                                    setBillingGuid(params.row.guid);
                                                    setBillingMessageLog(params.row.message);
                                                    onDrawerOpen();
                                                };
                                                return (
                                                    <div
                                                        className="cursorPointer billing-error-log-detail-link"
                                                        onClick={onclick}
                                                    >
                                                        {t('general.show')}
                                                    </div>
                                                );
                                            },
                                        },
                                    ]}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                ) : (
                    <div className="billing-error-log-empty-state">
                        <SCUINoRecordComponent />
                        <Box
                            className="billing-error-log-empty-actions"
                            sx={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: '16px' }}
                        >
                            <SCUIButton
                                className="billing-error-log-billing-errors-button"
                                text={t('billingServiceLog.billingErrors')}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                onClick={failedInvoiceList}
                            />
                        </Box>
                    </div>
                )}
            </Box>
        </SCUIContent>
    );
};
